import { useContext, useState } from "react"
import { useSearchParams, useNavigate } from "react-router-dom"
import { Row, Col, Form, Input, Button, message } from "antd"
import { TiFlashOutline } from "react-icons/ti"
import { MyContext } from "../../App"

export function ResetPassword() {

      const navigate = useNavigate()
      const { AppData } = useContext(MyContext)
      const [searchParams] = useSearchParams()
      const [loading, setLoading] = useState(false)

      const token = searchParams.get("token")

      const onFinish = async (values) => {

            if (!token) {
                  message.error("Reset link is invalid.")
                  return
            }

            if (values.newPassword !== values.confirmPassword) {
                  message.error("Passwords do not match.")
                  return
            }

            setLoading(true)

            try {

                  const response = await fetch(`${AppData.api.base}/auth/reset-password`, {
                        method: "POST",
                        headers: {
                              "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                              token,
                              newPassword: values.newPassword
                        })
                  })

                  const data = await response.json()

                  if (data.status === "success") {
                        message.success("Password updated. Please sign in.")
                        navigate("/")
                  } else {
                        message.error(data.result || "Unable to reset password.")
                  }

            } catch (err) {

                  console.log(err)
                  message.error("Something went wrong. Please try again.")

            }

            setLoading(false)

      }

      return (
            <>
                  <Row justify="center">
                        <Col xs={22} md={8} style={{ textAlign: 'center' }}>
                              <TiFlashOutline style={{ color: '#E41882', fontSize: '90px', marginTop: '100px' }} />
                              <Row justify="center" style={{ marginTop: '25px', padding: '75px 0 50px 0', background: 'rgba(0,0,0,0.01)' }}>
                                    <Col xs={22} lg={16}>
                                          <Form
                                                name="reset-password"
                                                layout="vertical"
                                                onFinish={onFinish}
                                          >
                                                <Form.Item
                                                      label="New Password"
                                                      name="newPassword"
                                                      rules={[
                                                            { required: true, message: 'Please enter a new password' }
                                                      ]}
                                                >
                                                      <Input.Password />
                                                </Form.Item>

                                                <Form.Item
                                                      label="Confirm Password"
                                                      name="confirmPassword"
                                                      rules={[
                                                            { required: true, message: 'Please confirm your new password' }
                                                      ]}
                                                >
                                                      <Input.Password />
                                                </Form.Item>

                                                <Form.Item>
                                                      <Button type="primary" htmlType="submit" loading={loading}>
                                                            Reset Password
                                                      </Button>
                                                </Form.Item>
                                          </Form>
                                    </Col>
                              </Row>
                        </Col>
                  </Row>
            </>
      )

}

